module.exports = __webpack_public_path__ + "img/uy.604bb74f.svg";